import {aresFormDataReducer} from './Ares/FormData/aresFormDataReducer';
import {aresFormHeadersReducer} from './Ares/formHeadersReducer';
import {aresSnapshotsReducer} from './Ares/Snapshots/aresSnapshotsReducer';
import {aresTaskDetailsReducer} from './Ares/TaskList/taskDetailsReducer';
import {aresTaskDocumentsReducer, navigationPanelReducer} from './Ares/taskDocumentsReducer';
import {aresTaskListReducer} from './Ares/TaskList/tasklistreducer';
import {aresFormDataByBodyTypeIdReducer} from './Ares/FormDataByBodyType/aresFormDataByBodyTypeReducer';
import {aresMyRiskFactorDescriptionReducer} from './Ares/RiskFactors/aresMyRiskFactorDescriptionReducer';
import {aresLinkedDocumentsReducer} from './Ares/LinkedDocuments/linkedDocumentsReducer';
import taskRelatedDocumentsReducer from './Ares/taskRelatedDocumentsReducer';
import {entityFormsReducers} from './EntityForms/entityformsreducer';
import {aresCompareBodiesReducer} from './Ares/Compare/aresCompareBodiesReducer';
import {stEntityIdReducer} from './Ares/stEntityIdReducer';
import relatetaskreducer from './RelateTask/relatetaskreducer';
import markCompleteTasksReducer from './MarkComplete/markCompleteTasksReducer';

const specialBodiesReducers = {};

export const reducers = {
	aresFormData: aresFormDataReducer,
	aresFormHeaders: aresFormHeadersReducer,
	aresTaskRelatedDocuments: taskRelatedDocumentsReducer,
	aresSnapshots: aresSnapshotsReducer,
	aresTaskDetails: aresTaskDetailsReducer,
	aresTaskDocuments: aresTaskDocumentsReducer,
	aresTaskList: aresTaskListReducer,
	aresFormDataByBodyTypeId: aresFormDataByBodyTypeIdReducer,
	aresMyRiskFactorDescriptions: aresMyRiskFactorDescriptionReducer,
	aresLinkedDocuments: aresLinkedDocumentsReducer,
	aresCompareBodies: aresCompareBodiesReducer,
	entityForms: entityFormsReducers,
	stEntityId: stEntityIdReducer,
	relateTask: relatetaskreducer,
	markCompleteTasks: markCompleteTasksReducer,
	navigationPanel: navigationPanelReducer,
	...specialBodiesReducers
};
